import CityPageToldos from "../components/CityPageToldos";

export default function ToldosAntequera() {
  return (
    <CityPageToldos
      name="Antequera"
      slug="antequera"
      cp="29200"
      poblacion={41000}
      zonaGeo="Antequera y Norte"
      lat={37.0181}
      lng={-4.5594}
      zonas={["Centro Antequera", "El Romeral", "Bobadilla", "La Estación"]}
      landmarks={["Alcazaba", "Dólmenes UNESCO", "El Torcal"]}
      municipiosLimitrofes={["Mollina", "Archidona", "Casabermeja", "Campillos"]}
      festivalLocal="Real Feria de Agosto, finales de agosto"
      contextoTipologico="Ciudad monumental interior con clima continental extremo (verano +35°C), demanda toldos protección solar intensa para casas históricas y comercios."
      isCoreZone={false}
    />
  );
}